import { ClientListsManager } from '../components/ClientListsManager';
import { useSubscriberListsQuery } from '../hooks/useSubscriberQueries';

/** An RM's own client books: only they (and admins) see who is on them. Send to them from any answer. */
export function MyListsPage() {
  const lists = useSubscriberListsQuery({ mine: true });
  return (
    <ClientListsManager
      title="My client lists"
      description="Your own WhatsApp lists. Only you and admins see who is on them; only opted-in numbers receive messages."
      lists={lists}
    />
  );
}
